<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="MailingBossFormComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">


    <delete-confirmation-modal ref="discardCaptcha" :custom="true" :title="$t('discard')"
                               :message="$t('ct-remove-recaptcha-confirm')" :confirmMessage="$t('ct-remove')"
                               @confirm="saveReCaptcha('', '')"/>

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <sync-drag :target="this"/>

      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-MailingBossFormComponent'>
        <img src="static/images/icons/engrenagem.svg"
             class="svg-icon normal-action"
             v-tooltip="{content:$t('ct-option-set-list'),  class: 'tooltip-custom'}"
             @click="listsOfUser"/>

        <img src="static/images/icons/list.svg"
             class="svg-icon normal-action"
             v-show="!internal_config.horizontal"
             v-tooltip="{content:$t('ct-option-grid'),  class: 'tooltip-custom'}"
             @click="changeColumns"
        />

        <img src="static/images/icons/list.svg"
             class="svg-icon normal-action"
             v-show="internal_config.horizontal"
             v-tooltip="{content:$t('ct-option-grid'),  class: 'tooltip-custom'}"
             @click="horizontalColumns"
        />

        <img src="static/images/icons/link.svg"
             v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action"
             @click="customURL"/>

        <img src="static/images/icons/social-proof-option.svg"
             class="svg-icon normal-action"
             v-tooltip="{content:$t('ct-option-socialproof'),  class: 'tooltip-custom'}"
             @click="openSocialProof"/>

        <img
          v-if="internal_config.recaptchaSiteKey"
          class="svg-icon normal-action"
          src="static/images/icons/delete.svg"
          v-tooltip="{content:$t('ct-option-remove-recaptcha'),  class: 'tooltip-custom'}"
          @click="clearRecaptcha()"
        />
        <img
          v-else
          class="svg-icon normal-action"
          src="static/images/icons/recaptcha.svg"
          v-tooltip="{content:$t('ct-option-set-recaptcha'),  class: 'tooltip-custom'}"
          @click="openModalRecaptcha()"
        />
      </options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>
      <form :class="horizontal ? 'form-mboss horizontal-form': 'form-mboss'" :target="internal_config.target"
            method="post" ref="form"
            :action="getAction">
        <div class="inputs-area" ref="container"></div>
        <div class="recaptcha-container" v-if="internal_config.recaptchaSiteKey">
          <vue-recaptcha :sitekey="internal_config.recaptchaSiteKey"></vue-recaptcha>
        </div>
        <div class="place-btn" :style="{ margin: buttonMargin }">
          <div class="bt-sb"
               v-bind:style="{
                        width : buttonWidth,
                        border : buttonBorder,
                        'border-radius': buttonRadius,
                        background: buttonBackground,
                        'box-shadow': buttonBoxShadow
                        }">
            <div class="bt-text-area d-flex align-items-center flex-wrap overflow-hidden"
                 v-bind:style="{minHeight: buttonHeight}">
              <a v-on:click="submit($event)" class="sb-text"
                 :style="textStyle()">{{ internal_config.button.text }}</a>
              <br v-show="internal_config.button.subText != ''"/>
              <small class="sb-sub-text" v-if="internal_config.button.subText"
                     :style="subTextStyle()">{{ internal_config.button.subText }}</small>
            </div>
          </div>
        </div>
      </form>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>

  </div>
</template>

<script>

import Vue from 'vue';
import Data from './Model';
import Resources from './Resources.vue';
import VueRecaptcha from 'vue-recaptcha';

import {
  getFields,
  setCustomUrl
} from '../../../../../js/services/integrations-internas/mailingboss';
import CheckFields from '../Fields/CheckFields.vue';
import SelectFields from '../Fields/SelectFields.vue';
import TextFields from '../Fields/Text.vue';
import DateFields from '../Fields/DateFields.vue';
import OptionsElementBar from "../../OptionsElementBar";
import ReCaptcha from "../../../resources/ReCaptcha";
import MixinForm from "../MixinForm.js";
import PhonePrefixField from '../Fields/PhonePrefixField.vue';
import FileField from '../Fields/FileField.vue';

export default {
  name: 'MailingBossFormComponent',
  props: ['config', 'id', 'preview', 'device'],
  mixins: [MixinForm],
  components: {
    OptionsElementBar,
    Resources,
    CheckFields,
    SelectFields,
    TextFields,
    DateFields,
    FileField,
    VueRecaptcha,
    ReCaptcha
  },
  computed: {
    getAction() {      
      if (this.internal_config.listUid !== '') {        
        return `${this.mbDomain}/lists/${this.internal_config.listUid}/subscribe`;
      }      
    },
    horizontal() {
      return this.internal_config.horizontal;
    },
    buttonWidth() {
      return parseInt(this.internal_config.button.width) + '%';
    },
    buttonHeight() {
      return parseInt(this.internal_config.button.height) + 'px';
    },
    buttonBorder() {
      return this.internal_config.button.border;
    },
    buttonBoxShadow() {
      return this.internal_config.button.boxShadow;
    },
    buttonRadius() {
      return this.internal_config.button.borderRadius;
    },
    buttonBackground() {
      let bg = this.internal_config.button.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
        bg += ' url("' + this.internal_config.button.backgroundImage + '")';
        bg += ' ' + this.internal_config.button.backgroundPosition;
        bg += ' / ' + this.internal_config.button.backgroundSize;
        bg += ' ' + this.internal_config.button.backgroundRepeat;
        bg += ' ' + this.internal_config.button.backgroundOrigin;
      }

      return bg;
    },
    buttonMargin() {
      const horizontal = this.internal_config.horizontal
      const margin = this.internal_config.button.margin

      return horizontal ? `0px 0px 0px ${margin}px` : `${margin}px 0px 0px`
    }
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },

  data() {
    return Data.data({
      mbDomain: ''
    });
  },
  methods: {

    customURL() {
      this.$root.$emit('openMailingBossFormModal', this.internal_config, this, this.saveURL, 'urls_modal');
    },

    openSocialProof() {
      this.$root.$emit('openFormConfigSocialProofConfigModal', this.internal_config, 'mailingboss-form', 'dataList', (config) => {
        this.internal_config = Object.assign({}, this.internal_config, config);
      });
    },

    saveURL() {
      setCustomUrl(JSON.stringify(Object.assign({}, this.internal_config.urlMboss)), this.internal_config.listUid);
      this.$refs.urls_modal.close();
      this.$snotify.success('URL Saved!');
    },

    animation() {
      return true;
    },
    listsOfUser: function () {
      this.$root.$emit('openMailingBossFormModal', this.internal_config, this, this.selectList, 'config');
    },

    submit(e) {
      e.preventDefault();
      this.$refs.form.submit();
    },
    close() {
      if (this.internal_config.listUid === '') {
        $(this.$el).detach();
      }
      $(this.$el).css({zIndex: this.internal_config.zIndex});
      this.$refs.modal.close();
    },
    buildFields: function (vm) {
      this.$refs.container.innerHTML = '';

      // se o form possui campo de phone e phoneprefix, agrupa
      const hasBothPhoneFields = vm.internal_config.dataList.filter(f => ['PHONE', 'PHONEPREFIX'].includes(f.tag)).length == 2;

      vm.internal_config.dataList.forEach(field => {
        const {identifier} = field.type;
        let fieldComponent;

        if (field.tag == 'PHONEPREFIX' && hasBothPhoneFields) return
        if (field.tag == 'PHONE' && hasBothPhoneFields) fieldComponent = vm.createPhoneField();
        else if (identifier === 'textarea') fieldComponent = vm.createTextField(field, true);
        else if (identifier === 'text') fieldComponent = vm.createTextField(field, false);
        else if (identifier === 'multiselect') fieldComponent = vm.createDropDown(field, true);
        else if (identifier === 'dropdown') fieldComponent = vm.createDropDown(field, false);
        else if (identifier === 'datetime') fieldComponent = vm.createDateTime(field, true);
        else if (identifier === 'date') fieldComponent = vm.createDateTime(field, false);
        else if (identifier === 'checkbox') fieldComponent = vm.createCheckField(field, 'checkbox');
        else if (identifier === 'radio') fieldComponent = vm.createCheckField(field, 'radio');
        else if (identifier === 'file') fieldComponent = vm.createFileField(field);
        
        if (fieldComponent) {
          this.$refs.container.appendChild(fieldComponent);
        }
      });
      this.inputStyle();
      this.setColumns();
      this.$loading.hide();
    },
    getFields: function (dataRef, vm) {
      this.$loading.show();
      getFields(dataRef).then(res => {
        vm.internal_config.dataList = res.data.data;
        vm.buildFields(vm);
      });
    },
    selectList(config) {
      this.internal_config = Object.assign({}, this.internal_config, config);

      let vm = this;
      this.getFields(this.internal_config.listUid, vm);
      // vm.close();
    },
    onResize: function (x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);


      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    edit(e) {
      e.preventDefault();
      this.internal_config.src = prompt('src', this.internal_config.src);
    },

    textStyle() {
      let sizeMobile = typeof this.internal_config.button.textStyle.sizeMobile !== 'undefined' && this.internal_config.button.textStyle.sizeMobile ?
        this.internal_config.button.textStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.button.textStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
    },

    subTextStyle() {
      let sizeMobile = typeof this.internal_config.button.subTextStyle.sizeMobile !== 'undefined' && this.internal_config.button.subTextStyle.sizeMobile ?
        this.internal_config.button.subTextStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
    },
    rebuild() {
      let vm = this;
      let config = this.internal_config;
      this.$nextTick(() => {
        this.internal_config = {};
        vm.internal_config = Object.assign({}, vm.internal_config, config);
        this.$root.$emit('rSidebarEdition', vm);
        vm.buildIcon();
      });
    },
    buildIcon: function () {
      $(this.$el).find('i').detach();

      if (this.internal_config.button.icon !== '') {
        if (this.internal_config.button.iconPosition === 'left') {
          $('<i>').addClass(this.$addIconPrefix(this.internal_config.button.icon)).prependTo($(this.$el).find('.sb-text').get(0));
        }
        if (this.internal_config.button.iconPosition === 'right') {
          $('<i>').addClass(this.$addIconPrefix(this.internal_config.button.icon)).appendTo($(this.$el).find('.sb-text').get(0));
        }
      }
    },
    build(config) {
      this.internal_config = config;

      this.buildIcon();
    },
    style() {
      return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler: function (e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },

    createCheckField(field, type) {
      let ComponentClass = Vue.extend(CheckFields);
      let instance = new ComponentClass({
        propsData: {
          type: type,
          label: field.label,
          options: field.options,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          selected: [],
          data: field
        }
      });
      instance.$mount();
      return instance.$el
    },
    createDropDown(field, multiple) {
      var selected = multiple ? [] : '';

      if (field.default_value) {
        if (multiple) {
          selected.push(field.default_value);
        } else {
          selected = field.default_value
        }
      }

      let ComponentClass = Vue.extend(SelectFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          options: field.options,
          selected: selected,
          data: field,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          multiple: multiple
        }
      });
      instance.$mount();
      return instance.$el
    },
    createDateTime(field, useCurrent) {
      let ComponentClass = Vue.extend(DateFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          data: field,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          value: new Date().toString(),
          type: (useCurrent ? 'datetime' : 'date')
        }
      });
      instance.$mount();
      return instance.$el
    },
    createFileField(field) {
      console.log(field, this.internal_config)
      let ComponentClass = Vue.extend(FileField);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          value: '',
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          data: field,
        }
      });
      instance.$mount();
      return instance.$el
    },
    createTextField(field, area) {
      let ComponentClass = Vue.extend(TextFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          value: '',
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          data: field,
          area: area
        }
      });
      instance.$mount();
      return instance.$el
    },

    createPhonePrefixField(field, area) {
      let ComponentClass = Vue.extend(PhonePrefixField);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          options: field.options,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          value: '',
          data: field,
        }
      });
      instance.$mount();
      return instance.$el
    },

    createPhoneField() {
      const phoneConfig = this.internal_config.dataList.find(field => field.tag == 'PHONE')
      const phonePrefixConfig = this.internal_config.dataList.find(field => field.tag == 'PHONEPREFIX')
      const phoneField = this.createTextField(phoneConfig);
      const phonePrefixField = this.createPhonePrefixField(phonePrefixConfig);
      const wrapper = document.createElement('div');
      wrapper.classList.add('phone-field-wrapper');
      wrapper.appendChild(phonePrefixField);
      wrapper.appendChild(phoneField);
      return wrapper
    },

    inputStyle() {
      let vm = this;

      let elements = this.$el.getElementsByClassName('form-control');
      [].forEach.call(elements, function (el) {
        el.style.backgroundColor = vm.internal_config.inputBgColor;
        el.style.border = vm.internal_config.inputBorder;
        if (el.tagName === 'TEXTAREA' && vm.internal_config.textareaHeight) {
          el.style.height = vm.internal_config.textareaHeight;
          el.classList.add('form-control-textarea-has-height');
        } else {
          el.style.height = vm.internal_config.inputHeight;
        }
        el.style.borderRadius = vm.internal_config.inputRadius;

        el.style.fontFamily = vm.internal_config.inputStyle.family;
        el.style.fontSize = vm.internal_config.inputStyle.size;
        el.style.textAlign = vm.internal_config.inputStyle.align;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.color = vm.internal_config.inputStyle.color;
      });

      vm.$el.style.color = vm.internal_config.labelStyle;
    },
    saveReCaptcha(siteKey, secretKey) {
      this.internal_config.recaptchaSiteKey = siteKey;
      this.internal_config.recaptchaSecretKey = secretKey;
      this.$snotify.success(this.$t('ct-saved'));

    },

    clearRecaptcha() {
      this.$refs.discardCaptcha.open();
    },
    openModalRecaptcha() {
      this.$root.$emit('showReCaptcha', this.internal_config.recaptchaSiteKey, this.internal_config.recaptchaSecretKey, this.saveReCaptcha)
    }
  },

  created() {
    this.mbDomain  = typeof process.env.MB_URL  !== 'undefined' ? process.env.MB_URL  : 'https://app.mailingboss.com';
    
    if (typeof this.config.horizontal_config_mobile === 'undefined' && typeof this.config.horizontal_config !== 'undefined') {
      this.$props.config.horizontal_config_mobile = Object.assign({}, this.config.horizontal_config);
    }

    if (typeof this.config.button.textStyle.sizeMobile === 'undefined' || this.config.button.textStyle.sizeMobile === '') {
      this.$props.config.button.textStyle.sizeMobile = this.config.button.textStyle.size;
    }

    if (typeof this.config.button.subTextStyle.sizeMobile === 'undefined' || this.config.button.subTextStyle.sizeMobile === '') {
      this.$props.config.button.subTextStyle.sizeMobile =this.config.button.subTextStyle.size;
    }
  },

  mounted() {
    let vm = this;

    this.build(this.$props.config);

    this.internal_config = window.mergeRecursive(this.props, this.$props.config);
    this.internal_config.button.subText = this.internal_config.button.subtext;

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      this.$el.classList.add('preview');

      this.$el.addEventListener('mouseover', function () {
        document.body.style.setProperty('--button-background-color--hover', vm.internal_config.button.backgroundColorHover);
        document.body.style.setProperty('--button-text-color--hover', vm.internal_config.button.textColorHover);
      });
    }

    if (this.internal_config.listUid === '') {
      this.listsOfUser();
    } else {
      this.buildFields(this);
    }

    this.inputStyle();

    this.setColumns() 

    this.testAlan(this.internal_config.horizontal_config, this.internal_config.horizontal_config_mobile)


    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) {
        objIds.push(this.id)
      }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$refs.resourcesData.setValuesData(this);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sitebuilder-element-container .vdr,
.vdr, .bt-sb,
form.form-mboss {
  height: auto !important;
}

.preview .bt-sb:hover {
  cursor: pointer;
  background-color: var(--button-background-color--hover) !important;
  color: var(--button-text-color--hover) !important;
}

.place-btn {
  text-align: center;

  .bt-sb {
    display: inline-block;
  }

  .sb-text,
  .sb-sub-text {
    width: 100%;
  }
}

.bt-text-area {
  display: block;
}

[data-device="tablet"] .bt-text-area,
[data-device="mobile"] .bt-text-area {
  width: auto !important;
}

</style>
<style lang="scss">

.label-url-mboss {
  width: 45%;
  text-align: right;
  display: inherit;
  margin-right: 15px;
}

.list-item {
  display: block;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-top: 2px;
  cursor: pointer;
}

.list-item.selectedList {
  border: 1px solid blue;
}
.phone-field-wrapper {
  display: flex;
  > :first-child {
    //flex: 0 1 135px;
  }
  > :last-child {
    flex-grow: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/MailingBossForm/MailingBossForm.vue